import React, { useEffect, useState } from 'react'
import { Col, Row } from 'antd'
import lodash from 'lodash'
import { useParams } from 'react-router-dom'
import Chart from './components/Chart'
import MqttServer from '@/utils/mqttUtil'
import { getDeviceData } from '@/utils/getData'
import { FunGroup, StationVirtualPoint } from '@/type/stationType'
import ItemValue from './components/ItemValue'
import useGlobalConfigStore from '@/stores/globalConfig'
import useStationStore from '@/stores/oneStation'

const OndeNode: React.FC<{ label: string; value: string | number; unit: string }> = ({ label, value, unit }) => {
  return (
    <div className='oneNode'>
      <div className='nodeTitle'>
        <img className='one' src='/assets/image/Battery.svg' />
        <div className='jingdu'>
          <div className='value' style={{ width: `${Number(value) || 0}%` }}></div>
        </div>
        <div className='bfb'>
          <img src='/assets/image/gou.svg' />
          {value}
          {unit}
        </div>
      </div>
      {label}
    </div>
  )
}

const Battery: React.FC = () => {
  const { deviceId } = useParams()
  const mqtt_serve = useStationStore(state => state.mqtt_serve)
  const device = useStationStore(state => state.device)
  const station_virtual_label = useStationStore(state => state.station_virtual_label)
  const initFinished = useGlobalConfigStore(state => state.initFinished)
  let targetGroup: FunGroup | undefined,
    mqtt: MqttServer | undefined,
    uuid: string = '',
    id: number = 0
  const [capacity, setCapacity] = useState<{ label: string; value: number | string; unit: string }>({
    label: 'BMS-Battery_capacity',
    value: 0,
    unit: '%',
  })
  const [data, setData] = useState<{ label: string; value: number | string; unit: string }[]>([])
  const [chartPoints, setChartPoints] = useState<StationVirtualPoint[]>([])
  const [chartDeviceId, setChartDeviceId] = useState<number>(0)
  const [chartProperty, setChartProperty] = useState<{ label: string; code: string; unit: string }[]>([])

  const getData = async () => {
    if (targetGroup) {
      let res: any
      try {
        res = await getDeviceData(
          [{ device_id: Number(id), defines: targetGroup.funs.map(item => item.fun_code) }],
          mqtt as MqttServer,
          uuid
        )
        // console.log(res)
        if (res.code === 1) {
          res.data[0].datas.forEach((item: { id: number; property_code: string; value: string }) => {
            let targetFun = targetGroup?.funs.find(fun => fun.fun_code === item.property_code)
            if (targetFun) {
              targetFun.value = item.value
            }
          })
          // console.log(targetGroup)
        }
      } catch (e) {
        console.log(e)
      }
      const funs = targetGroup.funs

      const capacityTemp = {
        label: 'BMS-Battery_capacity',
        value: funs.find(item => item.fun_name === 'BMS-Battery_capacity')?.value || 0,
        unit: funs.find(item => item.fun_name === 'BMS-Battery_capacity')?.unit || '%',
      }
      setCapacity(capacityTemp)
      setData(
        funs
          .filter(item => item.fun_name !== 'BMS-Battery_capacity')
          .map(item => ({ label: item.fun_name, value: item.value, unit: item.unit }))
      )

      const targetLabel = station_virtual_label.find(item => item.type === 'cn')
      if (targetLabel) {
        setChartPoints(
          targetLabel.points.filter(
            item =>
              item.property_code === 'I' ||
              item.property_code === 'KRA' ||
              item.property_code === 'P' ||
              item.property_code === 'SOC'
          )
        )
      }
      setChartProperty([{ label: 'BMS-Battery_temperature', code: 'Battery_temperature', unit: '℃' }])
      setChartDeviceId(id)
    }
  }

  useEffect(() => {
    if (initFinished) {
      const targetDevice = lodash.cloneDeep(device.find(item => item.id === Number(deviceId)))
      if (targetDevice) {
        targetGroup = targetDevice.fun_group?.find(item => item.group_name === 'Battery')
        mqtt = mqtt_serve[targetDevice.mqtt_server_id]
        uuid = targetDevice.iot_gateway_uuid
        id = targetDevice.device_id
      }
      getData()
    }
  }, [initFinished])

  return (
    <div id='Battery'>
      <div className='battery-one'>
        <Row gutter={[16, 16]} align='middle'>
          <Col span={6}>
            <OndeNode label={capacity.label} value={capacity.value} unit={capacity.unit} />
          </Col>
          <Col span={18}>
            <Row>
              {data.slice(0, 6).map(item => (
                <Col span={8} key={item.label}>
                  <ItemValue {...item} />
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </div>
      <div className='battery-two'>
        <Row gutter={[16, 16]}>
          {data.slice(6, 12).map(item => (
            <Col span={8} key={item.label}>
              <ItemValue {...item} />
            </Col>
          ))}
        </Row>
      </div>
      <div className='Battery-charts'>
        <Chart deviceId={chartDeviceId} points={chartPoints} propertyCodes={chartProperty} />
      </div>
    </div>
  )
}

export default Battery

// import { Col, Row } from "antd"
// import React from "react"
// import NumberScroller from "@/components/NumberScroller"
// import Charts from "./components/Charts"

// interface OneNodeProps {
//   label: string
//   value: number | string
//   num?: number
//   unit?: string
//   status?: any //"success" | "error" 可以根据需要调整状态值
// }

// const OndeNode: React.FC<OneNodeProps> = ({ label, value, status, num }) => {
//   return (
//     <div className="oneNode">
//       <div className="nodeTitle">
//         <img className="one" src="/assets/image/Battery.svg" />
//         <div className="jingdu">
//           <div className="value" style={{ width: `${(num || 0) * 100}%` }}></div>
//         </div>
//         <div className="bfb">
//           <img src={`/assets/image/${status == "success" ? "gou" : "cha"}.svg`} />
//           {value}
//         </div>
//       </div>
//       {label}
//     </div>
//   )
// }
// const BatteryItem: React.FC<OneNodeProps> = ({ label, value, unit }) => {
//   return (
//     <div className="itemValue">
//       <div className="itemValue-label">{label}</div>
//       <div className="itemValue-value">
//         <NumberScroller targetNumber={value} />
//         <span>{unit}</span>
//       </div>
//     </div>
//   )
// }
// const ComponentName: React.FC = (props) => {
//   const test1 = {
//     label: "BMS-Battery_capacity",
//     num: 1,
//     value: "100%",
//     status: "success",
//   }
//   const testData = [
//     { label: "Year_discharge_powerWh:", value: "100", unit: "kWh" },
//     { label: "Year_load_power:", value: "200", unit: "kWh" },
//     { label: "Year_discharge_power:", value: "100", unit: "kWh" },
//     { label: "Year_load_power:", value: "200", unit: "kWh" },
//     { label: "Year_discharge_power:", value: "100", unit: "kWh" },
//     { label: "Year_discharge_power:", value: "100", unit: "kWh" },
//   ]
//   const testData2 = [
//     { label: "Year_discharge_powerWh:", value: "100", unit: "kWh" },
//     { label: "Year_load_power:", value: "200", unit: "kWh" },
//     { label: "Year_discharge_power:", value: "100", unit: "kWh" },
//     { label: "Year_load_power:", value: "200", unit: "kWh" },
//     { label: "Year_discharge_power:", value: "100", unit: "kWh" },
//     { label: "Year_discharge_power:", value: "100", unit: "kWh" },
//     { label: "Year_discharge_power:", value: "100", unit: "kWh" },
//     { label: "Year_discharge_power:", value: "100", unit: "kWh" },
//   ]
//   return (
//     <div id="Battery">
//       <div className="battery-data">
//         <div className="battery-one" style={{ padding: "0 15px" }}>
//           <Row gutter={[16, 16]} align="middle">
//             <Col span={6}>
//               <OndeNode label={test1.label} value={test1.value} status={test1.status} num={test1.num} />
//             </Col>
//             <Col span={18}>
//               <Row>
//                 {testData.map((v, k) => {
//                   return (
//                     <Col span={8}>
//                       <BatteryItem label={v.label} value={v.value} unit={v.unit} />
//                     </Col>
//                   )
//                 })}
//               </Row>
//             </Col>
//           </Row>
//         </div>
//         <div className="battery-two" style={{ padding: "0 15px" }}>
//           <Row gutter={[16, 16]}>
//             {testData2.map((v, k) => {
//               return (
//                 <Col span={6}>
//                   <BatteryItem label={v.label} value={v.value} unit={v.unit} />
//                 </Col>
//               )
//             })}
//           </Row>
//         </div>
//       </div>
//       <div className="Battery-charts">
//         <Charts />
//       </div>
//     </div>
//   )
// }

// export default ComponentName
